import { render } from "./AuthBody.vue?vue&type=template&id=39546f02"
import script from "./AuthBody.vue?vue&type=script&lang=js"
export * from "./AuthBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__